export const COVERS_HALFCARD_CONSTANTS = {
    TITLE: "How many people are at the table?",
    DESCRIPTION: "This helps us serve cutlery accordingly",
    INPUT_LABEL: "Enter the count here",
    CTA_TEXT: "Submit",
    ILLUSTRATION_ID: "portal/static-assets/images/Group_1686557390.png",
    ILLUSTRATION_ALT: "Number of guests",
    ILLUSTRATION_SIZE: 48,
    ICON_WRAPPER_SIZE: 48,
};

export const COVERS_MIN = 1;
export const COVERS_MAX = 100;
export const COVERS_MAX_DIGITS = String(COVERS_MAX).length;

export const OBJECT_NAME = "guest-details";

export const OBJECT_VALUES = {
    IMPRESSION_ENTRY: "guest-details-entry",
    CLICK_SUBMIT: "guest-details-submit",
    CLICK_CLOSE: "guest-details-close",
};
